var GradientContainer = require('./gradientcontainer');

function WebkitGradientContainer(imageData) {
    GradientContainer.apply(this, arguments);
    this.type = imageData.args[0] === "linear" ? GradientContainer.TYPES.LINEAR : GradientContainer.TYPES.RADIAL;
}

WebkitGradientContainer.prototype = Object.create(GradientContainer.prototype);

module.exports = WebkitGradientContainer;



//////////////////
// WEBPACK FOOTER
// ./~/aframe-htmltexture-component/vendor/html2canvas/webkitgradientcontainer.js
// module id = 260
// module chunks = 0